import React from "react";
import { GridProps, Grid as ChakraGrid } from "@chakra-ui/react";

const Grid: React.FC<GridProps> = ({ children, ...rest }) => {
  return (
    <ChakraGrid
      templateColumns={{
        base: "1fr",
        sm: "repeat(2, 1fr)",
        lg: "repeat(3, 1fr)"
      }}
      columnGap={{ base: 4, lg: 6 }}
      rowGap="6"
      {...rest}
    >
      {children}
    </ChakraGrid>
  );
};

export default Grid;
